import { get } from 'lodash/fp';
import { useMemo } from 'react';
import { BankIntegrationProvider } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';
import { createBankIntegrationValidator } from './useBankIntegrationFormValidation';

const useBankFormValidator = (isUpdate = false) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredString('displayName'),
                validators.requiredString('legalName.defaultValue'),
                validators.requiredString('moduleId'),
                validators.requiredString('email'),
                validators.requiredNumber('order'),
                validators.validEmail('email'),
                validators.requiredString('color'),
                validators.requiredString('remoteFlowAcknowledgmentInfo'),

                validators.only(
                    () => !isUpdate,
                    validators.compose(
                        validators.requiredArray('availableFinanceProductTypes'),
                        validators.requiredStringEnum('integrationProvider', BankIntegrationProvider),
                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Email,
                            validators.nest(
                                'integrationSettings.email',
                                createBankIntegrationValidator(BankIntegrationProvider.Email)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Hlf,
                            validators.nest(
                                'integrationSettings.hlf',
                                createBankIntegrationValidator(BankIntegrationProvider.Hlf)
                            )
                        ),
                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Hlfv2,
                            validators.nest(
                                'integrationSettings.hlfV2',
                                createBankIntegrationValidator(BankIntegrationProvider.Hlfv2)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Uob,
                            validators.nest(
                                'integrationSettings.uob',
                                createBankIntegrationValidator(BankIntegrationProvider.Uob)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.BmwFs,
                            validators.nest(
                                'integrationSettings.bmwFs',
                                createBankIntegrationValidator(BankIntegrationProvider.BmwFs)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Maybank,
                            validators.nest(
                                'integrationSettings.maybank',
                                createBankIntegrationValidator(BankIntegrationProvider.Maybank)
                            )
                        ),

                        validators.only(
                            values => get('integrationProvider', values) === BankIntegrationProvider.Enbd,
                            validators.nest(
                                'integrationSettings.enbd',
                                createBankIntegrationValidator(BankIntegrationProvider.Enbd)
                            )
                        )
                    )
                )
            ),
        [isUpdate]
    );

    return useValidator(validator);
};

export default useBankFormValidator;
